import FilterPills from 'components/Catalog/Filters/FilterPills/FilterPills';
import { withFilterPillsProps } from 'components/Catalog/Filters/FilterPills/withFilterPillsProps';

export default withFilterPillsProps(FilterPills);
